<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        The graph shown below shows the kinetics curves for the reaction of oxygen with hydrogen to
        form water:
      </p>

      <p class="pl-12 mb-5">
        <chemical-latex content="O2(g) + 2 H2(g) -> 2 H2O(g)" />
      </p>

      <p class="mb-2">
        <v-img
          :src="$publicAsset('/img/assignments/kineticsOfWaterFormationReaction.png')"
          max-width="491px"
        />
      </p>

      <p class="mb-n3">a) Which of the curves below represents hydrogen gas?</p>

      <v-radio-group
        v-model="inputs.multipleChoiceAnswer"
        class="ml-6 mb-0"
        :disabled="!allowEditing"
      >
        <v-radio v-for="option in options" :key="option.value" class="my-1" :value="option.value">
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>

      <p class="mb-2">b) I think this because:</p>

      <p class="mb-n2">
        <s-textarea v-model="inputs.explainedResponse" outlined />
      </p>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';
import STextarea from '@/common/components/STextarea.vue';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'UBC154KineticsPrelabQuestion11',
  components: {
    ChemicalLatex,
    STextarea,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        multipleChoiceAnswer: null,
        explainedResponse: null,
      },
      options: [
        {text: 'The black curve', value: 'black curve'},
        {text: 'The dashed curve', value: 'dashed curve'},
        {text: 'The gray curve', value: 'gray curve'},
        {text: 'Any of the curves could be hydrogen', value: 'any curve'},
        {text: 'Either the gray or black curve', value: 'gray or black'},
      ],
    };
  },
};
</script>
